import {
  DialogCloseX,
  DialogContent,
  DialogHeading,
  DialogBody,
  DialogButton,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ReactNode } from "react"

import styles from "./DataSource.module.scss"
import { usePolyglot } from "src/contexts"

interface Props {
  children?: ReactNode;
}

const polyglotPrefix = "pages.settings.data_source.tandem_mobile_app_dialog."

export function TandemMobileAppDialogContent(props: Props) {
  const polyglot = usePolyglot()

  return (
    <DialogContent>
      {props.children}
      <DialogHeading className={styles.tandemDialogTitle}>
        {polyglot.t(`${polyglotPrefix}title`)}
        <DialogCloseX id="close-tandem-data-source-dialog-button" />
      </DialogHeading>
      <DialogBody>
        <div className={styles.openTandemAppMessage1}>
          {polyglot.t(`${polyglotPrefix}description_one`)}
        </div>
        <div className={styles.openTandemAppMessage2}>
          {polyglot.t(`${polyglotPrefix}description_two`)}
        </div>
        <DialogButton
          stylePreset="primary"
          id="ok-button"
        >
          {polyglot.t(`${polyglotPrefix}confirm_cta`)}
        </DialogButton>
      </DialogBody>
    </DialogContent>
  )
}
